module.exports = __webpack_public_path__ + "img/9791195587131.6b07d001.jpg";